import React from 'react';
import {Flex, Text} from '@chakra-ui/react';
import {FilterControl} from './FilterControl';
import {AccountFilterCondition} from '../../../shared/filter/accountFilter';
import {useFilterStore} from '../filterStore';

export const FilterItemList = ({
  availableOptions,
  staticTagsOnly,
}: {
  availableOptions: AccountFilterCondition['field'][];
  staticTagsOnly?: boolean;
}) => {
  const {
    filterItems,
    updateFilterCondition,
    removeFilterItem,
    filterOperator,
    setFilterOperator,
  } = useFilterStore();

  if (filterItems.length === 0) {
    return (
      <Text color="kgray.300" fontSize="sm">
        No filters are applied
      </Text>
    );
  }

  return (
    <Flex gap={4} flexDirection="column">
      {filterItems.map((filterItem, index) => (
        <FilterControl
          key={filterItem.id}
          index={index}
          filterItem={filterItem}
          availableOptions={availableOptions}
          filterOperator={filterOperator}
          onOperatorChange={setFilterOperator}
          onUpdateCondition={(newItem) =>
            updateFilterCondition(filterItem.id, newItem)
          }
          onRemove={() => removeFilterItem(filterItem.id)}
          staticTagsOnly={staticTagsOnly}
        />
      ))}
    </Flex>
  );
};
